"use client"

/**
 * Global wizard trigger system
 * Allows triggering the iOS install wizard from anywhere in the app
 */

// Event name for custom event
const WIZARD_TRIGGER_EVENT = 'ios-wizard-trigger'

/**
 * Trigger the iOS install wizard programmatically
 * @param delay - Optional delay in milliseconds before showing (default: 10000 = 10 seconds)
 * @param force - Force show even if already shown this session (default: false)
 */
export function triggerIOSWizard(delay: number = 10000, force: boolean = false) {
  if (typeof window === 'undefined') return

  // Dispatch custom event that the wizard component will listen to
  const event = new CustomEvent(WIZARD_TRIGGER_EVENT, {
    detail: { delay, force }
  })
  window.dispatchEvent(event)
}

/**
 * Listen for wizard trigger events
 * @param callback - Function to call when wizard should be triggered
 * @returns Cleanup function to remove event listener
 */
export function onWizardTrigger(callback: (delay: number, force: boolean) => void): () => void {
  if (typeof window === 'undefined') return () => {}

  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<{ delay: number; force: boolean }>
    callback(customEvent.detail.delay, customEvent.detail.force)
  }

  window.addEventListener(WIZARD_TRIGGER_EVENT, handler)

  return () => {
    window.removeEventListener(WIZARD_TRIGGER_EVENT, handler)
  }
}
